module.exports = __webpack_public_path__ + "img/No-Photo.e7960f53.jpg";